import type { GetFeedbackResponseBody, JsonObject } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetFeedbackOptions = { listingId: string; appointmentId: string };

export type Feedback = JsonObject<GetFeedbackResponseBody>;

const getFeedback = async ({
  listingId,
  appointmentId,
}: GetFeedbackOptions) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/appointment/${appointmentId}/feedback`,
    method: 'get',
  };

  const { data } = await axios.request<Feedback>(config);

  return data;
};

export default getFeedback;
